import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import axiosInstance from '../../config/axiosInterceptor';
import { toast } from 'react-toastify';

const EditPlan = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const planId = queryParams.get('id');

    const [plan, setPlan] = useState(null);
    const [themes, setThemes] = useState([]);
    const [frames, setFrames] = useState([]);
    const [total, setTotal] = useState(0);

    useEffect(() => {
        if (!planId) return;

        axiosInstance.get(`/admin/plan?id=${planId}`)
            .then(res => {
                if (res.data.success) {
                    setPlan(res.data.details);
                } else {
                    toast.error(res.data.message);
                }
            })
            .catch(err => toast.error(err.message));

        axiosInstance.get(`/admin/plan/getPlanAssets?type=1`).then(res => {
            if (res.data.success) setThemes(res.data.data);
        });

        axiosInstance.get(`/admin/plan/getPlanAssets?type=0`).then(res => {
            if (res.data.success) setFrames(res.data.data);
        });
    }, [planId]);

    useEffect(() => {
        if (plan) {
            const { rs = 0, SGST = 0, CGST = 0 } = plan;
            const t = parseFloat(rs) + parseFloat(SGST) + parseFloat(CGST);
            setTotal(t);
        }
    }, [plan?.rs, plan?.SGST, plan?.CGST]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setPlan(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!plan.title || !plan.coins || !plan.rs) {
            toast.error("Title, Coins and INR fields are required.");
            return;
        }

        const payload = {
            id: planId,
            title: plan.title,
            coins: plan.coins,
            rs: plan.rs,
            SGST: plan.SGST,
            CGST: plan.CGST,
            total: parseFloat(plan.rs) + parseFloat(plan.SGST || 0) + parseFloat(plan.CGST || 0),
            theme: plan.theme,
            frame: plan.frame
        };

        try {
            const res = await axiosInstance.put(`${process.env.REACT_APP_BASEURL5}/admin/plan/updatePlan`, { data: payload });
            if (res.data.success) {
                toast.success(res.data.message);
                setTimeout(() => navigate('/admin/managePlan'), 1000);
            } else {
                toast.error(res.data.message);
            }
        } catch (err) {
            toast.error(err.message);
        }
    };

    if (!plan) return <p>Loading...</p>;

    return (
        <>
            <section className="content-header">
                <h1>Edit Plan</h1>
                <ol className="breadcrumb">
                    <li><Link to="/admin"><i className="fa fa-dashboard" /> Home</Link></li>
                    <li><Link to="/admin/managePlan">Manage Plan</Link></li>
                    <li className="active">Edit Plan</li>
                </ol>
            </section>

            <section className="content">
                <div className="row">
                    <div className="col-md-12">
                        <form onSubmit={handleSubmit}>
                            <div className="box box-warning">
                                <div className="box-header with-border">
                                    <h3 className="box-title">Edit</h3>
                                </div>
                                <div className="box-body">
                                    <div className="form-group">
                                        <label>Title*</label>
                                        <input type="text" className="form-control" name="title" value={plan.title} onChange={handleChange} />
                                    </div>
                                    <div className="form-group">
                                        <label>Coin*</label>
                                        <input type="number" className="form-control" name="coins" value={plan.coins} onChange={handleChange} />
                                    </div>
                                    <div className="form-group">
                                        <label>Rupees (INR)*</label>
                                        <input type="number" className="form-control" name="rs" value={plan.rs} onChange={handleChange} />
                                    </div>
                                    <div className="form-group">
                                        <label>SGST</label>
                                        <input type="number" className="form-control" name="SGST" value={plan.SGST} onChange={handleChange} />
                                    </div>
                                    <div className="form-group">
                                        <label>CGST</label>
                                        <input type="number" className="form-control" name="CGST" value={plan.CGST} onChange={handleChange} />
                                    </div>
                                    <div className="form-group">
                                        <label>Total Amount</label>
                                        <input type="number" className="form-control" value={total} readOnly />
                                    </div>
                                    <div className="form-group">
                                        <label>Select Theme</label>
                                        <select className="form-control" name="theme" value={plan.theme} onChange={handleChange}>
                                            <option value="">-- Select Theme --</option>
                                            {themes.map(theme => (
                                                <option key={theme._id} value={theme._id}>
                                                    {theme.name ?? "THEME"} ({theme.valid} hours)
                                                </option>
                                            ))}
                                        </select>
                                        {themes.map(theme => (
                                            plan.theme === theme._id &&
                                            <img key={theme._id} src={`${process.env.REACT_APP_BASEURL}${theme.image}`} alt={theme.name} style={{ height: '100px', marginTop: '10px' }} />
                                        ))}
                                    </div>
                                    <div className="form-group">
                                        <label>Select Frame</label>
                                        <select className="form-control" name="frame" value={plan.frame} onChange={handleChange}>
                                            <option value="">-- Select Frame --</option>
                                            {frames.map(frame => (
                                                <option key={frame._id} value={frame._id}>
                                                    {frame.title ?? "FRAME"} ({frame.valid} hours)
                                                </option>
                                            ))}
                                        </select>
                                        {frames.map(frame => (
                                            plan.frame === frame._id &&
                                            <img key={frame._id} src={`${process.env.REACT_APP_BASEURL}${frame.thumbnail}`} alt={frame.name} style={{ height: '100px', marginTop: '10px' }} />
                                        ))}
                                    </div>
                                    <div className="form-group">
                                        <button type="reset" className="btn btn-danger">Cancel</button>
                                        <input type="submit" className="btn btn-success pull-right" value="Update" />
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
        </>
    );
};

export default EditPlan;
